import { IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN } from './theme';

export const TRIAL_LENGTH_DAYS = 30;
export const PLUS_WELCOME_HUB_VISIBILITY_WINDOW_DAYS = 30;
export const SAVINGS_GUARANTEE_LAUNCH_DATE = '2026-08-03';
export const SAVINGS_GUARANTEE_LAUNCH_DATE_DISPLAY = 'August 3, 2026';
export const MEMBERSHIP_COST = 69;
export const CARRIER_SHIP_FEE_REDUCTION = 3;
export const PRIVATE_LABEL_MAX_DISCOUNT = 60;
export const PRIVATE_LABEL_ITEM_COUNT = 300;

export const BRANDING_NAME = {
    [MISFITS_THEME_DOMAIN]: 'Misfits+',
    [IMPERFECT_THEME_DOMAIN]: 'Imperfect+',
};

export const SHORT_BRANDING_NAME = {
    [MISFITS_THEME_DOMAIN]: 'M+',
    [IMPERFECT_THEME_DOMAIN]: 'IF+',
};

export const AVERAGE_MEMBERSHIP_SAVINGS = {
    dbi: {
        year: 373.88,
    },
    cs: {
        year: 479.96,
    },
};

export const CART_SAVINGS_BANNER_DISMISSED = 'CART-SAVINGS-BANNER-DISMISSED';
export const PLUS_MEMBERSHIP_FT_CART_SAVINGS_BANNER_DISMISSED = 'PLUS-MEMBERSHIP-FT-CART-SAVINGS-BANNER-DISMISSED';
